import {
  TOGGLE_RISK_REQUEST,
  TOGGLE_RISK_SUCCESS,
  TOGGLE_RISK_FAILURE,
  UPDATE_RISK_REQUEST,
  UPDATE_RISK_SUCCESS,
  UPDATE_RISK_FAILURE,
  CLEAR_RISK
 } from '../constants'
import Api from '../services/api.js'

export function toggleRiskRequest(){
  return {
    type: TOGGLE_RISK_REQUEST
  }
}

export function toggleRiskSuccess(result, id, hidden){
  return {
    type: TOGGLE_RISK_SUCCESS,
    result: result,
    id: id,
    hidden: hidden
  }
}

export function toggleRiskFailure(exception){
  return {
    type: TOGGLE_RISK_FAILURE,
    exception: exception
  }
}

export function updateRiskRequest(){
  return {
    type: UPDATE_RISK_REQUEST,
  }
}

export function updateRiskSuccess(body, cellValue, row){
  return {
    type: UPDATE_RISK_SUCCESS,
    body: body,
    cellValue: cellValue,
    row: row
  }
}

export function updateRiskFailure(exception){
  return {
    type: UPDATE_RISK_FAILURE,
    exception: exception
  }
}

export function clearRisk(){
  return {
    type: CLEAR_RISK
  }
}

export function toggleRisk(plan_id, risk_id, hidden) {
  let params = {
    hidden: hidden.toString()
  }
  return dispatch => {
    dispatch(toggleRiskRequest())
    const api = new Api();
    return api.toggleRisk("/api/v1/plan/" + plan_id + "/risk/" + risk_id, params)
    .then(response => {
      dispatch(toggleRiskSuccess(response.data.result, risk_id, hidden))
    })
    .catch(error => dispatch(toggleRiskFailure(error)));
  }
}

export function toggleAllRisks(plan_id, hidden) {
  let params = {
    hidden: hidden.toString()
  }
  return dispatch => {
    dispatch(toggleRiskRequest())
    const api = new Api();
    return api.toggleRisk("/api/v1/plan/" + plan_id + "/toggle_risks", params)
    .then(response => {
      dispatch(toggleRiskSuccess(response.data.result, 'all', hidden))
    })
    .catch(error => dispatch(toggleRiskFailure(error)));
  }
}

export function updateRisk(plan_id, risk, cellValue, row) {
  let params = {
    risk: risk
  }
  return dispatch => {
    dispatch(updateRiskRequest())
    const api = new Api();
    return api.put("/api/v1/plan/"+ plan_id + "/update_risk", params)
    .then(response => {
      dispatch(updateRiskSuccess(response.data, cellValue, row))
    })
    .catch(err => dispatch(updateRiskFailure(err)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/risk.js